import styled from "styled-components/macro";
import { MenuItem, Select } from "@mui/material";
import { DeviceType } from "../../utils/hooks/useDeviceHook";

export const HelpMainOuterContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(3, auto);
  place-items: center;
  padding-bottom: 10px;
`;

export const HelpStandardImage = styled.img``;

export const HelpPageWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const getHelpWidth = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "920px";
  }
  if (deviceType === "tablet") {
    return "570px";
  }
  return "calc(100vw - 30px)";
};

const getHelpPadding = (deviceType: DeviceType) => {
  if (deviceType === "desktop") {
    return "90px 142px 142px 142px";
  }
  if (deviceType === "tablet") {
    return "60px 18px 112px 18px";
  }
  return "40px 0px 92px 0px";
};

export const HelpPageComponentWrapper = styled.div<{
  deviceType: DeviceType;
}>`
  display: grid;
  grid-template-columns: ${({ deviceType }) => getHelpWidth(deviceType)};
  padding: ${({ deviceType }) => getHelpPadding(deviceType)};
`;

export const HelpGeneralContainer = styled.div<{
  padding: string;
  paddingBottom?: string;
}>`
  margin-top: 20px;
  padding: ${({ padding }) => padding};
  background-color: ${({ theme }) => theme.white};
  box-shadow: ${({ theme }) => theme.boxShadow};
  max-width: 920px;
  border-radius: 24px;
  padding-bottom: ${({ paddingBottom }) => paddingBottom};
`;

export const HelpGeneralContainerSecondary = styled(HelpGeneralContainer)`
  height: 325px;
`;

export const HelpPageResources = styled.div<{
  deviceType: DeviceType;
}>`
  display: ${({ deviceType }) => (deviceType !== "desktop" ? "" : "grid")};
  grid-template-columns: ${({ deviceType }) =>
    deviceType !== "desktop" ? "" : "455px 430px"};
  grid-template-rows: ${({ deviceType }) =>
    deviceType !== "desktop" ? "" : undefined};
  max-width: ${({ deviceType }) => (deviceType === "mobile" ? "" : undefined)};
  grid-gap: 24px;

  ${HelpGeneralContainer} {
    padding: ${({ deviceType }) =>
      deviceType === "mobile" ? "24px 16px 30px 16px" : "20px"};
  }
`;

export const HelpFAQAnswerWrapper = styled.div`
  p {
    display: inline;
  }
  table,
  th,
  td {
    border: 1px solid;
    border-collapse: collapse;
  }

  td {
    padding: 8px 8px;
  }
`;

export const TopicSelectorHelpText = styled("div")`
  font-size: 16px;
  color: #929499;
  margin-left: 12px;
  margin-top: 15px;
  margin-bottom: 10px;
`;

export const HelpTopicSelect = styled(Select)`
  background: #fff;
  box-shadow: 0px 6px 11px 0px rgba(0, 0, 0, 0.04);
  width: 100%;

  .MuiInputBase-input {
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: var(--Secondary-Grey-Medium, #5d5a5a);
  }
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export const HelpTopicSelectMenuItem = styled(MenuItem)`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: var(--Secondary-Grey-Medium, #5d5a5a);

  &.Mui-selected {
    background-color: #eff8f5;
  }
`;
